import name from './name'

const selectSliceData = state => state[name]
const selectProgress = state => {
  const progress = selectSliceData(state).progress
  const total = selectSliceData(state).total
  return Math.round(progress / total * 100)
}

const selectLoading = state => selectSliceData(state).loading

const selectResult = state => selectSliceData(state).result

export {
  selectProgress,
  selectLoading,
  selectResult
}
